import { useTranslations } from 'next-intl';
import { SkeletonParent } from '@/components/ui/Skeleton/skeleton';

interface Props {
  isLoading: boolean;
}

export default function FilterHeader({ isLoading }: Props) {
  const t = useTranslations('lobby.filters');

  return (
    <div className="flex justify-between gap-2 items-center mb-4.25">
      {isLoading
        ? <SkeletonParent className="h-6.5 w-36" />
        : <p className="text-white font-medium text-lg leading-5.5">{ t('search-results')}</p>}
    </div>
  );
}
